var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
import { useConnection, useAnchorWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { Vault, Flex, VaultClient, vaultUtils, } from "@zetamarkets/flex-sdk";
import { getSolanaAddresses, getSolanaNetwork, isProduction, } from "../utils/env";
export var useFlexVault = function () {
    var connection = useConnection().connection;
    var anchorWallet = useAnchorWallet();
    var network = getSolanaNetwork();
    var _a = getSolanaAddresses(), flexAddress = _a.flex, vaultProgramId = _a.vault;
    var _b = useState(null), flexClient = _b[0], setFlexClient = _b[1];
    var _c = useState(null), flexVault = _c[0], setFlexVault = _c[1];
    // FLEX VAULT INITIALIZER
    useEffect(function () {
        if (!isProduction()) {
            console.time("SOL Vault Data Fetch"); // eslint-disable-line
        }
        var pollingInterval = flexVault ? 10000 : 3000;
        var setVault = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var vaultAddress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(Flex.isInitialized && Vault.isInitialized)) return [3 /*break*/, 2];
                        return [4 /*yield*/, vaultUtils.getVaultAddress("rSOL-THETA")];
                    case 1:
                        vaultAddress = (_a.sent())[0];
                        setFlexVault(Vault.getVault(new PublicKey(vaultAddress)));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }, pollingInterval);
        return function () {
            if (!isProduction()) {
                console.timeEnd("SOL Vault Data Fetch"); // eslint-disable-line
            }
            clearInterval(setVault);
        };
    }, [flexVault]);
    // FLEX VAULT HANDLER
    useEffect(function () {
        var loadFlexVault = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            Flex.load(new PublicKey(flexAddress), network, connection),
                            Vault.load(new PublicKey(vaultProgramId), network, connection),
                        ]).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var vaultAddress;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, vaultUtils.getVaultAddress("rSOL-THETA")];
                                    case 1:
                                        vaultAddress = (_a.sent())[0];
                                        return [2 /*return*/, Vault.getVault(new PublicKey(vaultAddress))];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        if (!Flex.isInitialized &&
            !Vault.isInitialized &&
            !flexVault &&
            connection) {
            loadFlexVault().then(function (vault) {
                setFlexVault(vault);
            });
        }
    }, [connection, flexVault, flexAddress, network, vaultProgramId]);
    // FLEX CLIENT HANDLER
    useEffect(function () {
        var loadFlexClient = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, VaultClient.load(connection, anchorWallet)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        if (anchorWallet && !flexClient && connection) {
            loadFlexClient().then(function (client) {
                setFlexClient(client);
            });
        }
    }, [anchorWallet, connection, flexClient]);
    var update = function () {
        if (Flex)
            Flex.updateState();
    };
    return { vault: flexVault, client: flexClient, update: update };
};
//# sourceMappingURL=useFlexVault.js.map